export const SOCIAL_AUTH_STORAGE_KEYS = {
  OAUTH_STATE: 'social_auth_oauth_state',
  REFERRAL: 'social_auth_referral',
  CONTINUE_URL: 'social_auth_continue_url',
};
